/**
 * Scrolls the target element into view within a custom scroll container.
 * Falls back to native scrollIntoView if no container selector is provided.
 */
export const scrollTargetIntoView = (targetSelector, containerSelector) => {
  if (!targetSelector) return;
  const target = document.querySelector(targetSelector);
  if (!target) return;

  if (!containerSelector) {
    target.scrollIntoView({ block: 'center', behavior: 'smooth' });
    return;
  }

  const container = document.querySelector(containerSelector);
  if (!container) {
    target.scrollIntoView({ block: 'center', behavior: 'smooth' });
    return;
  }

  const containerRect = container.getBoundingClientRect();
  const targetRect = target.getBoundingClientRect();
  const scrollTop = container.scrollTop + (targetRect.top - containerRect.top) - containerRect.height / 3;
  container.scrollTo({ top: Math.max(0, scrollTop), behavior: 'smooth' });
};
